import { Validators } from '@angular/forms';

export function ValidationsFactory(validation: string) {
  const [code, param] = validation.split(':');
  switch (code) {
    case 'minLength':
      return Validators.minLength(Number(param));
    case 'maxLength':
      return Validators.maxLength(Number(param));
    case 'min':
      return Validators.min(Number(param));
    case 'max':
      return Validators.max(Number(param));
    default:
      return null;
  }
}
